import { type Meta } from '@air/analytics';

const META: Meta = {
  description: 'User closed asset details panel',
  name: 'closed_asset_details',
  params: [
    {
      description: 'The asset ID',
      name: 'asset_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The clip/version ID of the asset',
      name: 'clip_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
